module.exports = __webpack_public_path__ + "static/media/6 1 Ordforstaelse Intro.d08b4268.mp3";